const DEFAULT_MENU = 'product'
const DEFAULT_MENU_WHEN_SKU = 'design'
const SKU_MATCHES = ['garment']

// TODO: Add types.
export { DEFAULT_MENU, DEFAULT_MENU_WHEN_SKU, SKU_MATCHES }
